module.exports = __webpack_public_path__ + "static/parade-2020-house13-779efb527d6f13a292097a35b4dd072b.jpg";